import { PolygonList } from "../../../../pages/MainPage/pages/Preferences/tabs/PolygonsEditor/type";
import mapConstants from "../../../constants/map.constants";

export default function set(value: PolygonList) {
	return {
		type: mapConstants.polygons.set,
		payload: value,
	};
}
